{
  "Needs action now": "לטיפול עכשיו",
  "Waiting for customer": "ממתין ללקוח",
  "Response overdue": "חריגה מזמן המענה",
  "Snoozed": "טיפול נדחה",
  "Assigned to me": "באחריותי",
  "Response target": "יעד למענה",
  "{n} minutes": "{n} דקות",
  "Response time is elapsed time, including closed hours. Snoozing hides the chat until it is due or the customer writes again.": "זמן המענה כולל גם שעות שבהן העסק סגור. דחיית טיפול מסתירה את השיחה עד למועד שנקבע או עד להודעה חדשה מהלקוח.",
  "{n} chats passed the response target": "{n} שיחות חרגו מיעד המענה",
  "Waiting for team": "ממתין לצוות",
  "Waiting since {time}": "ממתין מאז {time}",
  "Handoff context": "פרטי ההעברה לטיפול",
  "Latest customer request": "הבקשה האחרונה של הלקוח",
  "Reason for handoff": "סיבת ההעברה",
  "Recent replies": "תשובות אחרונות",
  "Next step": "הצעד הבא",
  "Assign an owner, then review the request and reply.": "שייכו אחראי, עברו על הבקשה והשיבו ללקוח.",
  "Wait for the customer, or set a follow-up task.": "המתינו ללקוח או הגדירו משימת מעקב.",
  "Review the request and reply, or set a follow-up task.": "עברו על הבקשה והשיבו, או הגדירו משימת מעקב.",
  "{n} open follow-up tasks": "{n} משימות מעקב פתוחות",
  "Waiting on": "ממי ממתינים לתשובה",
  "Detect from replies": "זיהוי לפי ההתכתבות",
  "Snooze": "דחיית טיפול",
  "Remind me in…": "להזכיר לי בעוד…",
  "1 hour": "שעה",
  "3 hours": "3 שעות",
  "24 hours": "24 שעות",
  "Resume now": "להחזיר לטיפול עכשיו",
  "Snoozed until {time}": "הטיפול נדחה עד {time}",
  "Improve your AI agent": "שיפור סוכן ה־AI",
  "Review suggestions": "לבדיקת ההצעות",
  "{n} improvements from real conversations are waiting for your approval.": "{n} הצעות שיפור מתוך שיחות אמיתיות ממתינות לאישורך.",
  "Nothing changes until you approve it.": "השינויים יוחלו רק לאחר אישורך.",
  "Source conversations": "השיחות שעליהן מבוססת ההצעה",
  "Conversation {n}": "שיחה {n}"
}
